module.exports = __webpack_public_path__ + "static/media/DSC_0157.fbb985b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0157.jpg
// module id = 691
// module chunks = 0